document.addEventListener('DOMContentLoaded', () => {

    const firebaseConfig = {
        apiKey: "AIzaSyDJngLtHVQ-1Q_muZPQBsYczWX0e6LNV8w",
        authDomain: "bestathu-80012.firebaseapp.com",
        projectId: "bestathu-80012",
        storageBucket: "bestathu-80012.appspot.com",
        messagingSenderId: "944448419154",
        appId: "1:944448419154:web:becfe8ffa4599c873a768b"
    };

    firebase.initializeApp(firebaseConfig);
    const auth = firebase.auth();
    const db = firebase.firestore();

    const loadingSpinner = document.getElementById('loading-spinner');
    const pageContent = document.getElementById('page-content');

    auth.onAuthStateChanged(user => {
        if (user) {
            // Notandi er innskráður, athugum hvort hann sé samþykktur meðlimur
            const userDocRef = db.collection('userProgress').doc(user.uid);
            userDocRef.get().then(doc => {
                if (doc.exists && doc.data().isMember === true) {
                    // Allt í lagi, birta síðuna
                    loadingSpinner.style.display = 'none';
                    pageContent.style.display = 'block';
                    // Keyra AOS hreyfingar eftir að innihald er birt
                    AOS.init({ duration: 800, once: true });
                } else {
                    // Ekki samþykktur meðlimur, senda á aðalsíðu
                    window.location.href = '/pages/bestathuclub';
                }
            }).catch(error => {
                console.error("Villa við að sækja notandagögn:", error);
                window.location.href = '/pages/bestathuclub';
            });
        } else {
            // Notandi ekki innskráður, senda á aðalsíðu
            window.location.href = '/pages/bestathuclub';
        }
    });
});